import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileCompletionCard = ({ completionScore, missingFields }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'success';
    if (score >= 60) return 'warning';
    return 'destructive';
  };

  const scoreColor = getScoreColor(completionScore);

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Profile Completion</h3>
        <div className={`text-2xl font-bold text-${scoreColor}`}>
          {completionScore}%
        </div>
      </div>
      <div className="mb-4">
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className={`bg-${scoreColor} h-2 rounded-full transition-all duration-300`}
            style={{ width: `${completionScore}%` }}
          />
        </div>
      </div>
      {missingFields?.length > 0 && (
        <div className="space-y-2">
          <p className="text-sm font-medium text-foreground">Complete these sections:</p>
          <div className="space-y-1">
            {missingFields?.map((field, index) => (
              <div key={index} className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Circle" size={12} />
                <span>{field}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCompletionCard;